import { Injectable, inject } from '@angular/core';
import { type Observable } from 'rxjs';

import { HttpClientService } from './http-client.service';
import type {
  EmailAnalyticsCharts,
  EmailAnalyticsChartsParams,
  EmailAnalyticsClient,
} from '../tokens/email-analytics-client.token';
import { EMAIL_ANALYTICS } from '../../shared/constants/api-routes.constants';

@Injectable({ providedIn: 'root' })
export class EmailAnalyticsService implements EmailAnalyticsClient {
  private readonly http = inject(HttpClientService);

  getCharts(params: EmailAnalyticsChartsParams): Observable<EmailAnalyticsCharts> {
    const url = EMAIL_ANALYTICS.CHARTS(params.incidentNumber);
    return this.http.get<EmailAnalyticsCharts>(url, {
      params: { medicationName: params.medicationName },
    });
  }
}
